import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface MasterunitsState {
  data: string[];
}
const initialState: MasterunitsState = {
  data: [],
};
const MasterUnits = createSlice({
  name: "MasterUnits",
  initialState,
  reducers: {
    setMasterUnits: (state: any, action: PayloadAction<string[]>) => {
      state.data = action.payload;
    },
  },
});

export const { setMasterUnits } = MasterUnits.actions;
export default MasterUnits;
